"use client"

import { Modal } from "antd"
import LoginForm from "./LoginForm"
import { forwardRef, useCallback, useImperativeHandle, useState } from "react"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type LoginModalProps = {
  onSwitchToSignup?: () => void;
};

export type LoginModalRef = {
  open: () => void,
  close: () => void,
}

const LoginModal = forwardRef<LoginModalRef, LoginModalProps>((props, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const isDesktop = useIsDesktop()

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  const handleLoginSuccess = (userData: any) => {
    setOpen(false); // Close the modal
  };

  return (
    <Modal
      centered
      styles={{
        container: {
          padding: '2.4rem',
          paddingBottom: 0
        }
      }}
      onCancel={handleClose}
      open={isDesktop && open}
      footer={() => null}
      width={"48rem"}
    >
      <LoginForm onLoginSuccess={handleLoginSuccess} onSwitchToSignup={props.onSwitchToSignup}/>
    </Modal>
  )
})

export default LoginModal